// How a visitor can get the Android app. Two routes, and the page picks one.
//
// Play Store is the route for production: it is build-time config, because a
// Play listing either exists or it does not. A direct APK is the route for beta,
// where testers need a build before there is any listing - and there the URL
// alone is not enough proof. The manifest CI writes beside the APK is what
// actually confirms the file landed; publishing the URL before the build once
// left a dead link on the live site, and that gate is why it cannot recur.

export const playStoreUrl = process.env.NEXT_PUBLIC_PLAY_STORE_URL || '';

export const apkUrl = process.env.NEXT_PUBLIC_APK_URL || '';

// Sits beside the APK, so deriving it from the URL keeps the two in step.
export const manifestUrl = apkUrl.replace(/[^/]+$/, 'latest.json');

export const isPlayStoreConfigured = playStoreUrl !== '';
export const isApkConfigured = apkUrl !== '';

export const minimumAndroidVersion = 'Android 7.0 or newer';

export type AppRelease = {
  file?: string;
  version?: string;
  size?: string;
  sizeBytes?: number;
  builtAt?: string;
  commit?: string;
};

// Shared across every download surface on the page, so the footer link and the
// page button do not each fetch the same file.
let pending: Promise<AppRelease | null> | null = null;

export function loadAppRelease(): Promise<AppRelease | null> {
  if (!isApkConfigured) {
    return Promise.resolve(null);
  }
  if (!pending) {
    pending = fetch(manifestUrl, { cache: 'no-store' })
      .then((response) => (response.ok ? (response.json() as Promise<AppRelease>) : null))
      .catch(() => null);
  }
  return pending;
}
